import {
  BRADEN_ACTIVITY_ANSWERS,
  BRADEN_FRICTION_AND_SHEAR_ANSWERS,
  BRADEN_MOBILITY_ANSWERS,
  BRADEN_MOISTURE_ANSWERS,
  BRADEN_NUTRITION_ANSWERS,
  BRADEN_SENSORY_PERCEPTION_ANSWERS,
} from '#src/terminology/instruments/instrumentTerminology.ts'
import {
  ownCoding,
  scoreBand,
  scoredItem,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

const SECTIONS: InstrumentSection[] = [
  {
    id: 'questions',
    items: [
      [
        'sensory-perception',
        'Sensory Perception - Ability to respond meaningfully to pressure-related discomfort',
        BRADEN_SENSORY_PERCEPTION_ANSWERS,
      ],
      [
        'moisture',
        'Moisture - Degree to which skin is exposed to moisture',
        BRADEN_MOISTURE_ANSWERS,
      ],
      [
        'activity',
        'Activity - Degree of physical activity',
        BRADEN_ACTIVITY_ANSWERS,
      ],
      [
        'mobility',
        'Mobility - Ability to change and control body position',
        BRADEN_MOBILITY_ANSWERS,
      ],
      [
        'nutrition',
        'Nutrition - Usual food intake pattern',
        BRADEN_NUTRITION_ANSWERS,
      ],
      [
        'friction-and-shear',
        'Friction and Shear',
        BRADEN_FRICTION_AND_SHEAR_ANSWERS,
      ],
    ].map(([item, label, answerSet]) =>
      scoredItem(ownCoding(`braden-${item}`, label), answerSet)
    ),
  },
]

// The form's four bands. The published Braden scale, and today's computed
// severity code, split 15 and over into mild risk (15-18) and no risk
// (19-23).
export const BRADEN_TEMPLATE: InstrumentTemplate = {
  id: 'braden',
  version: '1',
  panel: ownCoding('braden-panel', 'Braden scale'),
  title: 'Braden Scale',
  shortName: 'Braden',
  reference: 'https://www.in.gov/health/files/Braden_Scale.pdf',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'braden',
    coding: ownCoding('braden-total', 'Braden total score'),
    sections: SECTIONS,
    completeness: { requireAll: true },
    bands: [
      scoreBand({ max: 9 }, 'braden-severe-risk', 'Severe Risk', 'red'),
      scoreBand(
        { min: 10, max: 12 },
        'braden-high-risk',
        'High Risk',
        'orange'
      ),
      scoreBand(
        { min: 13, max: 14 },
        'braden-moderate-risk',
        'Moderate Risk',
        'yellow'
      ),
      scoreBand({ min: 15 }, 'braden-mild-risk', 'Mild Risk', 'green'),
    ],
  }),
}
